export default __webpack_public_path__ + "resources/icons/d322-af71.png";